import CustomButton from "components/Atoms/CustomButton"
import CustomDialog from "components/Atoms/CustomDialog"
import dayjs from "dayjs"
import { ShiftBeatMutation, useShiftBeatMutation } from "generated/graphql"
import React from "react"
import { stringOrDate } from "react-big-calendar"
import AppToaster from "utils/AppToaster"

export type EventType = {
  id?: string
  include?: stringOrDate
  exclude?: stringOrDate
  assigneeName?: string
  routeName?: string
}
type ShiftBeatTypes = {
  event?: EventType
  onClose?: () => void
  onCompleted?: (data: ShiftBeatMutation) => void
  id?: string
  start?: Date
  end?: Date
}
const ShiftBeat = ({ onClose, onCompleted, event }: ShiftBeatTypes) => {
  const [update, { loading }] = useShiftBeatMutation({
    onCompleted,
    onError({ graphQLErrors }) {
      graphQLErrors.forEach(({ message }) =>
        AppToaster.show({ message, intent: "danger", icon: "error" })
      )
    },
  })
  if (!event) return null

  const include = dayjs(event.include).format("Do MMM YYYY")
  const exclude = dayjs(event.exclude).format("Do MMM YYYY")
  const isShift = event.include && event.include

  return (
    <CustomDialog
      light
      footerRightButton={
        <CustomButton
          onClick={() => {
            update({
              variables: {
                id: event.id,
                excludeDate: dayjs(event.exclude).format("YYYY-MM-DD"),
                includeDate:
                  event.include && dayjs(event.include).format("YYYY-MM-DD"),
              },
            })
          }}
          text="Confirm"
          dark
          icon="endorsed"
          loading={loading}
        />
      }
      onClose={onClose}
      isOpen={event ? true : false}
      title={isShift ? "Shift Beat" : "Delete Beat"}
    >
      <p className="leading-relaxed">
        {isShift ? (
          <>
            Shift beat for route <b>{event.routeName}</b> from <b>{exclude}</b>{" "}
            to <b>{include}</b> for user <b>{event.assigneeName}</b> ?
          </>
        ) : (
          <>
            Delete beat for route <b>{event.routeName}</b> on <b>{exclude}</b>{" "}
            for user <b>{event.assigneeName}</b>
          </>
        )}
      </p>
    </CustomDialog>
  )
}

export default ShiftBeat
